export default __webpack_public_path__ + "static/media/fatal.50f515d7.png";